import { ComponentType } from "react";
import { useSelector } from "react-redux";
import { TAX_SYSTEMS_CODES } from "@helpers/taxSystemsCodes";
import { RootState } from "@store/store";
import { BienvenidaFirmaFactoraje } from "@pages/producto/credito_simple/bienvenida_firma/BienvenidaFirmaFactoraje";
import { BienvenidaFirmaDefault } from "@pages/producto/credito_simple/bienvenida_firma/BienvenidaFirmaDefault";

/**
 * Despacha a la pantalla de bienvenida a firma correcta según el producto del solicitante.
 * Cualquier tipo desconocido cae a la pantalla de marcador de posición.
 */
const SCREEN_BY_TYPE: Partial<Record<string, ComponentType>> = {
  [TAX_SYSTEMS_CODES.FLUX_PM]: BienvenidaFirmaFactoraje,
  [TAX_SYSTEMS_CODES.FLUX_PFAE]: BienvenidaFirmaFactoraje,
};

export const BienvenidaFirma = () => {
  const applicationType = useSelector((state: RootState) => state.register.application?.type);
  const Screen = (applicationType && SCREEN_BY_TYPE[applicationType]) || BienvenidaFirmaDefault;
  return <Screen />;
};
